import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../context-role-element';

export default {
  [CONTEXT.GENERAL]: {
    [ROLE.CONTAINER]: [
      ELEMENT.COMPONENT_RATING,
      ELEMENT.BREADCRUMB,
      ELEMENT.PRODUCT_CARD,
      ELEMENT.PRODUCT_CARD_VARIANTS,
      ELEMENT.SECTION_FAQ_FOOTER,
    ],
    [ROLE.CARD]: [ELEMENT.PRODUCT_CARD],
    [ROLE.BUTTON]: [
      ELEMENT.RANGE_INPUT,
      ELEMENT.PRODUCT_CARD_WISHLIST_BUTTON,
      ELEMENT.SECTION_FAQ_FOOTER_ITEM,
    ],
    [ROLE.FLAG]: [ELEMENT.PRODUCT_CARD_FREIGHT_FLAG, ELEMENT.PRODUCT_CARD_CAMPAIGN_FLAG],
    [ROLE.IMAGE]: [ELEMENT.PRODUCT_CARD_IMAGE],
    [ROLE.TEXT]: [
      ELEMENT.PRODUCT_CARD_NAME,
      ELEMENT.PRODUCT_CARD_PRICE_FROM,
      ELEMENT.PRODUCT_CARD_PRICE_TO,
    ],
  },
} as TValidTestId;
